// extracted by mini-css-extract-plugin
module.exports = {"qrMask":"QRLogin_qrMask__XOcdj"};